export default __webpack_public_path__ + "static/media/Montserrat-SemiBold.87718949.ttf";